import { render, staticRenderFns } from "./ObrigadoTarot.vue?vue&type=template&id=591d8a08"
import script from "./ObrigadoTarot.vue?vue&type=script&lang=js"
export * from "./ObrigadoTarot.vue?vue&type=script&lang=js"
import style0 from "./ObrigadoTarot.vue?vue&type=style&index=0&id=591d8a08&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports